import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RunSource } from '../shared/enums/run-source.enum';

@Component({
    selector: 'run-source-badge',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './run-source-badge.component.html',
    styleUrl: './run-source-badge.component.scss'
})
export class RunSourceBadgeComponent {
    @Input({ required: true }) source: RunSource = RunSource.Cloud;

    getBadgeClass(): string {
        switch (this.source) {
            case RunSource.Freight:
                return 'badge-freight';
            case RunSource.FreightBase:
                return 'badge-freight-base';
            case RunSource.Local:
                return 'badge-local';
            case RunSource.AllegroCase:
                return 'badge-allegro-case';
            case RunSource.OppCost:
                return 'badge-opp-cost';
            case RunSource.Cloud:
            default:
                return 'badge-cloud';
        }
    }
}
